import {
  DateOptionType,
  ExpenseType,
  FinanceType,
  LanguageType,
  SettingAreaPunchingType,
  TransactionType,
} from "@/enums/enums";
import { ContactModel } from "../contact/contactModel";
import { MerchantDetail } from "../merchant/merchantModel";
import { UserInfoModel } from "../user/userModel";
import {
  ColumnModel,
  CredentialModel,
  DocumentAccountModel,
  DocumentSummaryModel,
  ElementContactModel,
  ElementDefaultModel,
  ElementHeadTypeModel,
  ElementMerchantModel,
  ElementUserApproveModel,
  ElementUserCreateModel,
  ElementUserReviewedModel,
} from "./documentModel";
import { SettingJournalDocumentTemplateModel, SettingJournalTypeNameModel } from "./settingDocumentTemplate";

export class DocumentSubAccountModel {
  subAccountCode!: string;
  subAccountId!: number;
  subAccountRefType!: number;
}

export class JournalDocumentItemBaseModel {
  description!: string;
  credit!: number;
  debit!: number;
  account!: DocumentAccountModel;
  subAccount!: DocumentSubAccountModel;
}

export class JournalReferenceModel {
  referenceId!: number;
  referenceNumber!: string;
  referenceType!: number;
}

export class JournalDocumentModel {
  approvedDateTime!: Date;
  approvedUser!: UserInfoModel;
  contact!: ContactModel;
  createdDateTime!: Date;
  createdUser!: UserInfoModel;
  description!: string;
  items!: Array<JournalDocumentItemBaseModel>;
  journalDate!: Date;
  journalId!: number;
  journalNumber!: string;
  journalType!: number;
  totalCredit!: number;
  totalDabit!: number;
  isDeleted!: boolean;
  merchant!: MerchantDetail;
  statusType!: number;
  summary!: DocumentSummaryModel;
  tags!: Array<string>;
  updatedDateTime!: Date;
  updatedUser!: UserInfoModel;
  reviewedUser!: UserInfoModel;
  reference!: JournalReferenceModel;
  purchaseTaxInvoices!: Array<PurchaseTaxInvoiceModel>;
}

export class PurchaseTaxInvoiceModel {
  taxInvoiceDateTime!: Date;
  taxInvoiceNumber!: string;
}

export class JournalDocumentDetailModel {
  data!: JournalDocumentModel;
  version!: number;
}

export class JournalOnlineViewModel {
  document!: JournalDocumentDetailModel;
  template!: SettingJournalDocumentTemplateModel;
  transactionId!: number;
  transactionType!: number;
  financeType!: number;
  expenseType!: number;
  credential!: CredentialModel;
  headerOptionType!: number;
}

export class DetailJournalDocumentModel {
  itemList!: Array<ElementJournalItemModel>;
}

export class ElementJournalItemModel {
  description!: string;
  credit!: number;
  debit!: number;
  accountCode!: string;
  accountName!: string;
  accountNameEn!: string;
}

export class HeaderJournalDocumentModel {
  colorCode!: string;
  colorCodeCopy!: string;
  description!: string;
  language!: LanguageType;
  areaPunchingType!: SettingAreaPunchingType;
  merchantLogo!: ElementDefaultModel;
  headType!: ElementHeadTypeModel;
  documentNameType!: SettingJournalTypeNameModel;
  merchant!: ElementMerchantModel;
  contact!: ElementContactModel;
  documentInfo!: ElementJournalInfoModel;
}

export class ElementJournalInfoModel {
  dateOptionType!: DateOptionType;
  documentNoTitle!: ElementDefaultModel;
  issedDateTitle!: ElementDefaultModel;
  refTitle!: ElementDefaultModel;
  jonalTypeTitle!: ElementDefaultModel;
  journalRefTaxNumberTitle!: ElementDefaultModel;
  journalRefTaxDateTitle!: ElementDefaultModel;
  documentNo!: string;
  issedDate!: Date;
  ref!: string;
  jonalType!: number;
  journalRefTaxNumber!: string;
  journalRefTaxDate!: Date;
  isCustomTextDisplay!: boolean;
}

export class JournalDocumentTemplateModel {
  transactionType!: TransactionType;
  financeType!: FinanceType;
  expenseType!: ExpenseType;
  header!: HeaderJournalDocumentModel;
  detail!: DetailJournalDocumentModel;
  footer!: FooterJournalDocumentModel;
  isDeleted!: boolean;

  constructor() {
    this.header = new HeaderJournalDocumentModel();
    this.detail = new DetailJournalDocumentModel();
    this.footer = new FooterJournalDocumentModel();
  }
}

export class FooterJournalDocumentModel {
  debit!: number;
  credit!: number;
  certified!: ElementJournalCertifiedModel;

  constructor() {
    this.debit = 0;
    this.credit = 0;
    this.certified = new ElementJournalCertifiedModel();
  }
}

export class ElementJournalCertifiedModel {
  userCreateTitle!: ElementDefaultModel;
  userApproveTitle!: ElementDefaultModel;
  userReviewedTitle!: ElementDefaultModel;
  userCreate!: ElementUserCreateModel;
  userApprove!: ElementUserApproveModel;
  userReviewed!: ElementUserReviewedModel;
  isCustomTextDisplay!: boolean;
  isShowQRCode!: boolean;
}

export class HeaderJournalItemColumnModel {
  accountNo!: ColumnModel;
  accountName!: ColumnModel;
  description!: ColumnModel;
  debit!: ColumnModel;
  credit!: ColumnModel;
}
